import { coursesAdapter, userCoursesAdapter } from "./sliceUtils"
import { createSelector } from '@reduxjs/toolkit';
import { calculateFinishRate, calculateTop5FinishRate, calculatePassPercentageChartData } from "./selectorsUtils"

export const {
    selectAll: selectAllCourses,
    selectEntities: selectCoursesObj,
} = coursesAdapter.getSelectors((state) => state.dashboardState.coursesDetails);


export const {
    selectAll: selectAllUserCourses,
    selectEntities: selectUserCoursesObj,
} = userCoursesAdapter.getSelectors((state) => state.dashboardState.userCoursesDetails);

export const selectMonthlyProgressChartData = createSelector([selectAllUserCourses], (userCoursesData) => {
    if (!userCoursesData) return null;
    return calculateFinishRate(userCoursesData)
})

export const selectTopFiveChartData = createSelector([selectAllUserCourses, selectCoursesObj], (userCoursesData, coursesObj) => {
    if (!userCoursesData || !coursesObj) return null;
    return calculateTop5FinishRate(userCoursesData, coursesObj)
})

export const selectPassPercentageBlockData = createSelector([selectAllUserCourses], (userCoursesData) => {
    if (!userCoursesData) return null;
    return calculatePassPercentageChartData(userCoursesData)
})

